import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProfessionalAudience } from './components/ProfessionalAudience';
import { StatsBar } from './components/StatsBar';
import { Problems } from './components/Problems';
import { SessionMap } from './components/SessionMap';
import { Modules } from './components/Modules';
import { ModuleIncludes } from './components/ModuleIncludes';
import { Printables } from './components/Printables';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { PricingPack } from './components/PricingPack';
import { Guarantee } from './components/Guarantee';
import { CostOfNotBuying } from './components/CostOfNotBuying';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: MetaPixel;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}

// Pixel « T-R-C FR » (portfolio eurek_labs.france), le même que dans la boutique Impultienda.
// Ne jamais réutiliser celui d'une autre offre.
const META_PIXEL_ID = '1900405527421779';
export function App() {
  useEffect(() => {
    if (!META_PIXEL_ID) return;
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }

    // Même file d'attente que le code officiel de Meta : fbevents.js reprend les appels via callMethod.
    const fbq: MetaPixel = (...args: unknown[]) => {
      if (fbq.callMethod) fbq.callMethod(...args);else fbq.queue?.push(args);
    };
    fbq.push = fbq;
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/fr_FR/fbevents.js';
    document.head.appendChild(script);
    fbq('init', META_PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <main className="w-full overflow-x-hidden bg-mist font-sans text-navy antialiased" data-id="element-0" data-mp="3ud1en72ulk9k">
      <Hero data-id="element-1" data-mp="d4nuteha5g1c" />
      <ProfessionalAudience data-id="element-2" data-mp="d57hf8hvkslp" />
      <StatsBar data-id="element-3" data-mp="d3cvbquvaug1" />
      <Problems data-id="element-4" data-mp="d3wch5cp1et0" />
      <SessionMap data-id="element-5" data-mp="d2biphy7dzw7" />
      <Modules data-id="element-6" data-mp="85uj9rljzz3t" />
      <ModuleIncludes data-id="element-7" data-mp="85bbv4tj4t41" />
      <Printables data-id="element-8" data-mp="86w4uq0743zs" />
      <Comparison data-id="element-9" data-mp="86cld4uwd7jn" />
      <Bonuses data-id="element-10" data-mp="83qivjmv5i8a" />
      <PricingPack data-id="element-11" data-mp="3gl4rlhg1e0k1" />
      <Guarantee data-id="element-12" data-mp="3gklce8hrtq9p" />
      <CostOfNotBuying data-id="element-13" data-mp="3gm65ruscn35z" />
      <FAQ data-id="element-14" data-mp="3gja6o34rm8fy" />
      <FinalCTA data-id="element-15" data-mp="3gj1qo2dcin0j" />
      <Footer data-id="element-16" data-mp="3bmjs5k8lzkwn" />
    </main>;
}